import React, { useEffect, useState } from 'react'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';


function Carousel(props) {
    
    const [idx,setIdx] = useState(0);
    const [img,setImg] = useState(props.imgs[0]);
    
    useEffect(()=>{
        setIdx(idx+1);
    },[])
        
    useEffect(()=>{
        const timeout = setTimeout(()=>{
            setIdx((idx+1)%props.imgs.length)
        },5000)
        return () => clearTimeout(timeout);
    },[idx])

  return (
    
    <div className='pt-8 pb-8 flex flex-col justify-center items-center mt-[50px]' style={{background:`${props.gray?'#F7F7F7':'white'}`}}>
    
      <div className='flex justify-center items-center'>
      <div 
      className=' text-black'><ChevronLeftIcon onClick={()=>{
        if(idx===0){
            setIdx(props.imgs.length-1)
        }else{
            setIdx(idx-1)
        }
      }} style={{ fontSize:70 }}/></div>
        <img src={props.imgs[idx]} className='w-3/5 flex justify-center p-2 '/>
        <div 
      className=' text-black'><ChevronRightIcon 
      onClick={()=>{
        if(idx===props.imgs.length-1){
            setIdx(0)
        }else{
            setIdx(idx+1)
        }
      }} style={{ fontSize:70 }}/></div>
      </div>
      <div className='flex justify-start text-[20px] md:text-[30px]' style={{fontFamily:'sans-serif'}}>{props.title}</div>
      <p className='flex flex-1 flex-wrap text-[15px] md:text-[25px] w-5/6 md:w-3/5'>{props.para}</p>
      <p className='flex flex-1 text-[#007FFF] flex-wrap text-[15px] md:text-[25px] w-5/6 md:w-3/5'><a href={props.link}>Link - {props.link}</a></p>
      <div className='flex flex-wrap'>
      {props.keywords.map((tech)=>(
         <div key={tech}  style={{margin:5,padding:6,background:'#007fff',borderRadius:'10%',color:'white'}}>{tech}</div>
      ))}</div>
    </div>
  )
}

export default Carousel
